<header class="header">
  <div>
    <div class="header__wrapper">



      <div class="header_logo">
        <picture class="header_logo_mobile">
          <source>
          <source>
          <img src="./images/img/LOGO-M.png" />
        </picture>
        <div class="header_logo_mobile_2_wrapper">
          <picture class="header_logo_mobile_2">
            <source>
            <source>
            <img src="./images/img/LOGO-M-2.png" />
          </picture>
        </div>
      </div>


      <picture class="header_img_right">
        <source>
        <source>
        <img src="./images/img/LOGO-PC.png" />
      </picture>
      <div id="information">
        <a [routerLink]="['/','short-cut']" style="font-weight:bold; color:#900">＜ {{'回首頁'|translate}}</a>
        <ng-container *ngTemplateOutlet="name; context: {$implicit:  (clo013|async)}"></ng-container>

        <ng-template #name let-student>
          <b>{{'學號'|translate}}：</b>{{student?.stno}}<b>{{'姓名'|translate}}：</b>{{lang=='tw'?student?.cH_NAME:student?.engname}}
          <b>{{'狀態'|translate}}：</b>{{lang=='tw'?student?.studY_STATUS_NAME:student?.studY_STATUS_ENGNAME}}
          <b>{{'系所'|translate}}：</b>{{lang=='tw'?student?.teacH_GRP_NAME:student?.teacH_GRP_ENGNAME}}
        </ng-template>

        (<a href="javascript:void(0)" class="click" (click)="logout()">{{'登出'|translate}}</a>)
        <div class="language">
          <a href="javascript:void(0)" [ngClass]="{'click':lang=='tw'}" (click)="changeLang('tw')">繁中</a>/
          <a href="javascript:void(0)" [ngClass]="{'click':lang=='en'}" (click)="changeLang('en')">EN</a>
        </div>
      </div>
      <nav class="nav-outer " [ngClass]="{'nav-outer--active':openHead || (isMediumScreen|async) == false}">

        <ng-container *ngFor="let head of header;let i=index;">
          <a [routerLink]="head.routelink" class="nav-outer__link"
            (click)="head.child?.length <= 0 && openHeadMethod(false)"
            [ngClass]="{'nav-outer__link--active':outterLinkActive==head}" (click)="outterLinkActive= head">
            {{head.title | translate }}
          </a>
          <nav *ngIf="head.child?.length>0" class="nav-inner slider--frugal-style"
            [ngClass]="{'nav-inner--active':outterLinkActive==head && (openHead||(isMediumScreen|async) == false)}">
            <div class="splide__track">
              <div class="splide__list">
                <ng-container *ngFor="let ch of head.child;let j = index">
                  <a *ngIf="!ch.show || (ch.show|async)==true" [routerLink]="ch.routelink" [fragment]="ch.fragment"
                    [routerLinkActive]="(ch.fragment==undefined)?'nav-inner__link--active':''"
                    class="nav-inner__link splide__slide" [routerLinkActiveOptions]="{exact:true}"
                    (click)="openHeadMethod(false)">
                    {{ch.title | translate}}</a>
                </ng-container>


              </div>
            </div>
          </nav>

        </ng-container>

        <div class="burger" [ngClass]="{'burger--active':openHead}" (click)="openHeadMethod()" id="burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </div>
  </div>





</header>
